const getters = {
  // 是否火车票中转
  trainIsTransfer: (state) => state.indexTrain.trainIsTransfer,
  // 火车票中转列表是否重新刷新
  transferListRefresh: (state) => state.indexTrain.transferListRefresh,
  // 火车列表进入1.5详情数据
  trainDetailInfoVuex: (state) => state.indexTrain.trainDetailInfo || {},
  // 国际机票在线询价客服组id
  internationalAirTicketServiceGroupId: (state) => state.flightCommon.internationalAirTicketServiceGroupId,
  // 是否需要出差单
  needTravelFormVuex: (state) => state.common.needTravelFormVuex,
};
export default getters;
